import React, {useEffect, useState} from "react"
import {connect} from "react-redux"
import * as Sentry from '@sentry/browser'
import {ThunkDispatch} from "redux-thunk"
import {AnyAction, compose} from "redux"
import {getOperationList, requestFailed, setCurReport} from "../../store/infoList/actions"
import {
  MsgData,
  OperationMessages,
  OperationMessagesItem,
  OperationMessagesRootState,
  Property
} from "../../store/infoList/types"
import {ListView, PullToRefresh, Toast} from "antd-mobile"
import style from './InfoList.module.css'
import {genRowData, getImgTime, getListTime, jumpTopic, filteremoji} from "../../utils"
import {closeWebview, openWebview, setNavigation, trackNew} from "../../utils/bridge"
import {logRed, logYellow} from "../../utils/log"
import {Retry} from "../../components/retry/Retry"
import {OPERATION_LIMIT} from "../../utils/config"

type DispatchToPropsType = Readonly<{
  fetchOperationMessages: any,
  setCurReport: any,
  handleFail: (param: boolean) => void
}>

// 设置listView行数据
let rData: string[] = []
let pageIndex = 0
let index = 0
let refreshIndex = 0
let renderIndex = 0
let changeFlag = 0
const docHeight = '100vh'
const pageID = 'p_mytantan'
const eid = 'e_newmytantan_card'

const Index: React.FC<any> = (props: OperationMessages & DispatchToPropsType | any) => {
  console.log('render', ++renderIndex)
  const [operationList, setData] = useState<OperationMessagesItem[]>([])
  const [dataSource, setDataSource] = useState(new ListView.DataSource({
    rowHasChanged: (row1: any, row2: any) => row1 !== row2
  }))
  // 是否正在刷新数据
  const [refreshing, setRefresh] = useState<boolean>(true)
  // loading
  const [isLoading, setLoading] = useState<boolean>(true)

  // 拉取数据
  const getList = async (init = false) => {
    console.log('-----------------------------------------------------------getList')
    const {fetchOperationMessages, handleFail} = props
    if (props.allLoaded || props.isFetching) {
      return
    }
    try {
      setLoading(true)
      await fetchOperationMessages(init)
    } catch (error) {
      const msg = window.navigator.onLine ? '获取列表失败' : '网络连接断开'
      Toast.info(msg, 3)
      console.log('---------------------------------------------------------handleFail')
      handleFail(false)
      Sentry.withScope(scope => {
        scope.setExtra('error', error)
        Sentry.captureException(error)
      })
    }
    setLoading(false)
    setRefresh(false)
  }

  // 监听数据变化
  useEffect(() => {
    console.log('-----------------------------------------------------------props')
    const list = props.operationMessages
    if (list && list.length > 0) {
      setData(list)
      pageIndex++
      rData = [...rData, ...genRowData(refreshIndex, pageIndex, list.length)]
      setDataSource(dataSource.cloneWithRows(rData))
    }
  }, [props.operationMessages])

  // 初次拉取数据
  useEffect(() => {
    (async function () {
      rData = []
      await setNavigation({
        title: '我的探探',
        leftHandler() {
          closeWebview()
        },
        rightText: ' '
      })
      await getList(true)
    })()
  }, [])

  // 刷新数据
  const refresh = async () => {
    console.log('-----------------------------------------------------------refresh')
    pageIndex = 0
    index = 0
    rData = []
    refreshIndex++
    changeFlag = 1
    if (isLoading || refreshing) {
      return
    }
    setRefresh(true)
    await getList(true)
  }

  // 触底请求下一页数据数据
  const onEndReached = async () => {
    return
    // todo: 暂时不要分页
    // console.log('-----------------------------------------------------------onEndReached')
    // if (isLoading || refreshing) {
    //   return
    // }
    // setLoading(true)
    // await getList()
    // setLoading(false)
  }

  // 页面MC打点
  const trackMC = (card_id: string) => {
    trackNew({
      pageId: pageID,
      type: 'MC',
      eid,
      extras: {
        card_id: card_id
      }
    })
  }

  // 去日报页面
  const toDailyPage = async (content: string) => {
    trackMC('daily_report')
    await props.setCurReport(content)
    props.history.push('/daily/page')
  }

  // 去话题页面
  const toTopic = (operationItem: OperationMessagesItem) => {
    trackMC('topic')
    const property: Property = JSON.parse(operationItem.property) || {}
    jumpTopic(
      operationItem.attributeId,
      '',
      operationItem.link || '',
      property.topic_type || "topic",
      property.topic_name || ''
    )
  }

  // 去其他页面
  const toOther = (url: string, card_id: string) => {
    trackMC(card_id)
    openWebview(url)
  }
  const renderContent = (op: OperationMessagesItem) => {
    const property: Property = JSON.parse(op.property)
    let isDaily = false
    const styleFn = (radius: number) => {
      return {
        filter: `blur(${radius}px)`,
        '-webkit-filter': `blur(${radius}px)`
      }
    }
    switch (op.type) {
      // 纯图 - 话题
      case "topic":
        return <div
          className={style.cardBox}
          onClick={() => toTopic(op)}>
          <img className={`${style.coverImg} ${style.fullImg}`} src={op.cover} alt=""/>
        </div>
      // 信息 - 谁喜欢了我
      case "call_to_buy_see":
        const msgData: MsgData = JSON.parse(property?.msgData || '{}')
        return <div
          className={style.chatBox}
          onClick={() => toOther(msgData.button.href, 'ctbs')}>
          <img
            className={style.chatIcon}
            src={msgData.logoURL}
            alt=""/>
          <div className={`${style.chatContent}`}>
            <div className={style.chatCover}>
              <img
                src={msgData.medias[0].url}
                style={styleFn(msgData.medias[0].gaussianBlurParameters.htmlBlurRadius)}
                alt=""/>
            </div>
            <div className={style.chatText}>{msgData.text}</div>
            <div className={style.chatButton}>{msgData.button.text}</div>
          </div>
        </div>
      // 上图下文 - 日报
      case "daily_report":
        isDaily = true
        op.cover = 'https://auto.tancdn.com/v1/images/eyJpZCI6IlA2Uk80RUZRU0hDV1ZIUTM2SFJDQkZaQlRLUkNBQjA3IiwidyI6OTg0LCJoIjozMDAsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMTUyMTUyMTI4Mzg5MDk2NDE4OX0.png'
      // 上图下文 - 优惠卷
      case "coupon":
        // @ts-ignore
        return <div
          className={style.cardBox}
          onClick={() => {
            isDaily
              ? toDailyPage(property.reportContent || '')
              : toOther(op.link, 'discount')
          }}>
          <div style={{overflow: 'hidden', position: 'relative', borderRadius: '0.12rem'}}>
            <img className={style.coverImg} src={op.cover} alt=""/>
            {isDaily ? <div className={style.imgTime}>{getImgTime(op.createdTime)}</div> : ''}
          </div>
          <div className={style.infoBox}>
            <div className={style.title}>{property.title}</div>
            {isDaily
              ? <div className={style.subtitle} dangerouslySetInnerHTML={{__html: (filteremoji(property.subTitle || ''))}}/>
              : <div className={style.subtitle}>{property.subTitle}</div>}
          </div>
        </div>
      default:
        return <div className={style.nodata}>暂无相关模块</div>
    }
  }

  const renderRow = (rowData: any, sessionID: any, rowID: any) => {
    try {
      if (index >= operationList.length) {
        index = 0
      }
      // console.log('-----------------------------------------------------------renderRow')
      const op = operationList[rowID]
      const isLast = +rowID === operationList.length - 1
      // console.log(operationList.length,
      //   op,
      //   `sessionID -- [${sessionID}]`,
      //   `rowID -- [${rowID}]`,
      //   `isLoading -- [${isLoading}]`,
      //   `refreshing -- [${refreshing}]`,
      //   `pageIndex -- [${pageIndex}]`,
      //   `index -- [${index}]`)
      return !!op ? <div key={rowData} className={style.itemBox}>
        <div className={style.timeBox}>{isLast ? '' : getListTime(op.createdTime)}</div>
        {renderContent(op)}
      </div> : <span/>
    } catch (e) {
      logRed(JSON.stringify(e, null, 2))
      return <span/>
    }
  }

  // logYellow(
  //   `status = ${props.status}`,
  //   `isFetching = ${props.isFetching}`,
  //   `isLoading = ${isLoading}`,
  //   `refreshing = ${refreshing}`
  // )

  // todo: 如果请求失败展示重试
  // if (!props.status && !props.isFetching && !isLoading && !refreshing) {
  //   return <div style={{height: '100vh'}} onTouchStart={refresh}><Retry/></div>
  // }

  const renderLoading = () => {
    return <div style={{position: "absolute", width: '100vw', textAlign: "center", top: '-0.1rem'}}>
      <img style={{width: '0.3rem'}} src="/loading.gif" alt=""/>
    </div>
  }

  return <ListView
    className={style.listBox}
    initialListSize={1000}
    dataSource={dataSource}
    renderRow={renderRow}
    renderFooter={() => <div
      style={{textAlign: 'center', marginTop: 20, marginBottom: 10, color: '#ccc'}}>{isLoading ? '' : '没有更多'}</div>}
    pullToRefresh={<PullToRefresh
      style={{height: docHeight}}
      onRefresh={refresh}
      indicator={{
        activate: renderLoading(),
        deactivate: <span style={{display: 'none'}}/>,
        release: renderLoading(),
        finish: <span style={{display: 'none'}}/>,
      }}
      direction={'down'}
      distanceToRefresh={30}
      refreshing={refreshing}
      damping={200}
      getScrollContainer={() => <div/>}/>}
  />

}
const mapStateToProps = (state: OperationMessagesRootState) => {
  const {operationMessages, isFetching, allLoaded, lenLastFetch, isFirstFetch, status} = state.operationMessages
  return {
    operationMessages,
    isFetching,
    allLoaded,
    lenLastFetch,
    isFirstFetch,
    status
  }
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch<OperationMessagesRootState, void, AnyAction>
): DispatchToPropsType => {
  return {
    fetchOperationMessages: compose(dispatch, getOperationList),
    setCurReport: compose(dispatch, setCurReport),
    handleFail: compose(dispatch, requestFailed),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)



